import { APP_NAV_ITEMS } from "../../constants/appNavigation";
import type { User } from "./auth.types";
import { canAccessNavItem } from "./moduleAccess";

export function getDefaultAuthenticatedPath(user: User | null): string {
	const firstAccessible = APP_NAV_ITEMS.find((item) =>
		canAccessNavItem(user, item),
	);
	return firstAccessible?.href ?? "/unauthorized";
}
